/** Human-readable explanations for realtime conflict projections (RU). */

export function explainsConflict(kind: string | undefined): {
  title: string;
  explanation: string;
  suggestRefresh: boolean;
  highlightFieldsHint: string[];
} | null {
  switch (kind) {
    case 'ROUTE_VERSION_CONFLICT':
      return {
        title: 'Конфликт версии маршрута',
        explanation:
          'Маршрут был изменён на сервере (другим пользователем или во вкладке) до сохранения. Ваш локальный черновик может быть устаревшим.',
        suggestRefresh: true,
        highlightFieldsHint: []
      };
    case 'STOP_PATCH_GRAPH_STALE':
      return {
        title: 'Схема точек изменилась',
        explanation:
          'Порядок или состав точек маршрута на сервере не совпадает с вашим представлением. Обновите данные и проверьте точки перед повторной отправкой.',
        suggestRefresh: true,
        highlightFieldsHint: ['Точки маршрута', 'Позиции остановок']
      };
    case 'STOP_PATCH_EXECUTED_REORDER_FORBIDDEN':
      return {
        title: 'Изменение порядка невозможно',
        explanation:
          'Одна из точек уже исполнена (фактический заезд/выезд). Сервер блокирует перестановку таких точек без согласованного процесса.',
        suggestRefresh: true,
        highlightFieldsHint: ['Последовательность точек', 'Факт времени точки']
      };
    default:
      return null;
  }
}
